// Le seed de la base officielle se fait désormais via Node depuis la racine :
// node importWrestlers.js         → seed wrestlers_2k25 + wrestlers_2k26
// node importWrestlers.js 2k25    → seed uniquement wrestlers_2k25
// node importWrestlers.js 2k26    → seed uniquement wrestlers_2k26

export async function seedOfficialDatabase(force = false) {
  console.log('ℹ️ Le seed se fait via node importWrestlers.js depuis VSCode.');
}
